import { ChargebacksQueueFields } from "globalConstants";
import { ReviewTypeEnum } from "types";

const loadingStatuses = async (_search, _prevOptions, { page }) => {
	try {
		const reviewTypesStatus = ReviewTypeEnum.getOptions();
		return {
			options: reviewTypesStatus,
			hasMore: false,
			additional: {
				page: page + 1,
			},
		};
	} catch {
		return { options: [] };
	}
};

const reviewType = () => ({
	name: ChargebacksQueueFields.ReviewType.name,
	type: "select" as const,
	loadOptions: loadingStatuses,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	formatLabel: value => `${value?.displayName}`,
	placeholder: "Review Type",
});

export default reviewType;
